<template>
    <div class="px-2 w-full md:w-9/12 lg:w-7/12 m-auto mt-12 ">
      
        <div class="m-2  flex">
            <h1 class="text-xl flex-1">
                Feed Sources
            </h1>

            <a  href="javascript:void(0)" @click="openNewFeedSource"
              class="p-1 px-2 rounded border bg-blue-600 text-white">
                  + New Feed Source
            </a>
        </div>

      <div v-if="loading" class="text-center bg-white p-12 m-2">
        <svg  aria-hidden="true" class="w-8 h-8 m-auto text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="#e5e7eb" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#e5e7eb"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
      </div>
      <div v-else>
        <div v-for="(feedProcessor,i) in feedProcessors" :key="'feedProcessor-'+i"
          class="bg-white border flex m-1 cursor-pointer">

          <router-link  class="flex flex-1 p-2" :to="{path:'/FeedProcessor/'+feedProcessor._id }">
            <span class="flex-1 mx-3">{{ feedProcessor.title }}</span>
            <span class="mx-3 px-2 rounded h-fit" :class="{'bg-green-600 text-white':feedProcessor.active, 
            'bg-gray-200 text-black-900': !feedProcessor.active}">{{ feedProcessor.active? "On" : "Off" }}</span>
          </router-link >
          
          <router-link  :to="{path:'/Feeds/'+feedProcessor._id}"
          class="mx-3 text-blue-600 p-2"> Feeds </router-link >
        </div>
        
        <div v-if="!feedProcessors || !feedProcessors.length" class="bg-white rounded text-center p-4 border">
          <span>No Feed Sources Yet .. </span>
          <a href="javascript:void(0)" @click="openNewFeedSource" class="text-blue-600">
            Create New Feed Source
          </a>
        </div>
      </div>
        
     <NewFeedSource  ref="NewFeedSourceRef" :confirmedFun="getFeedProcessors"/>
    </div>
  </template>

<script>
  import NewFeedSource from '@/components/NewFeedSource'

  export default {
    name: 'Home',
    components: {
      NewFeedSource
    },
    async mounted(){
      this.getFeedProcessors()
    },
    data () {
      return {
        loading:false,
        feedProcessors:[],
      }
    },
    methods: {
      async getFeedProcessors(){
        if(!this.$store.state.user || !this.$store.state.user.email){return}

        this.loading = true;
        const res = await this.$store.state.axiosInstance.get(this.$store.state.API_ENDPOINT + '/v1/feedProcessors',{
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        this.loading = false;
        if(res.data && res.data.data){
            this.feedProcessors = res.data.data;
        }else {
          this.$store.state.toastr.open({timeOut:5000, type:"error", 
          title:'Failed ', text: 'Get feed sources failed'});
        } 
      },
  
      openNewFeedSource(){
        if(!this.$store.state.user || !this.$store.state.user.email){
          this.$store.state.loginPopupRef.open({tab: this.$store.state.ACCOUNT_TABS_LOGIN})
          return 
        }

        const { premiumPlan, plan } = this.$store.state.user
        const FreePlan = !premiumPlan && !this.feedProcessors.length;
        const BasicPlan = premiumPlan && plan === 'BASIC' && this.feedProcessors.length < 10;
        const AdvancedPlan = premiumPlan && plan === 'ADVANCED' && this.feedProcessors.length < 30;
        const Premium = premiumPlan && plan === 'PREMIUM' && this.feedProcessors.length < 120;

        if( FreePlan || BasicPlan || AdvancedPlan || Premium){
          this.$refs.NewFeedSourceRef.open({feedProcessorsLength: this.feedProcessors.length})
        }else{
          const FreePlanUpgradeMessage = `The free plan only allows a single feed source. 
          Upgrade to unlock additional sources`;

          
          const UpgradeMessage = `You've reached the limit of your current plan. Upgrade now to unlock more features. 
          
          Need help? Contact us for assistance!`;

          this.$store.state.toastr.open({timeOut:5000,type:"info",
          title:'Please Note ',text: premiumPlan? UpgradeMessage : FreePlanUpgradeMessage});
        }
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>


// WEBPACK FOOTER //
// src/pages/Home.vue